import React from 'react'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'

import GuidanceNote from '../../../components/GuidanceNote'
import { OC_ERROR_MESSAGES } from '../constants/ocConstants'
import { normalizeErrorDetails } from '../../../helpers/utils'
import {
  UI_COLOR_ACCENT_ORANGE_SOFT_HOVER,
  UI_COLOR_BLACK
} from '../../../constants/uiColors'

const NO_INSERTED_ACCENT = '#EF6C00'

const OcNotInsertedStatus = ({ details }) => {
  const normalized = normalizeErrorDetails(details)
  const message = normalized || OC_ERROR_MESSAGES.NO_INSERTED_FALLBACK

  return (
    <GuidanceNote
      icon={<WarningAmberOutlinedIcon />}
      title={`${OC_ERROR_MESSAGES.NO_INSERTED_PREFIX}:`}
      message={message}
      accentColor={NO_INSERTED_ACCENT}
      backgroundColor={UI_COLOR_ACCENT_ORANGE_SOFT_HOVER}
      textColor={UI_COLOR_BLACK}
      singleLine
      sx={{ mt: 1.5, mb: 0 }}
      messageSx={{ fontSize: '14px', fontWeight: 400 }}
    />
  )
}

export default OcNotInsertedStatus
